import React from "react";
import { Card } from "react-bootstrap";
import "./Experience.css";

const ExpCardView = ({ image, title, subtitle }) => {
  return (
    <Card className="exp-card h-100">
      <div className="exp-img-wrapper">
        <Card.Img
          className="exp-img img-fluid"
          variant="top"
          src={image}
          alt={title}
        />
      </div>
      <Card.Body className="exp-card-body">
        <Card.Title>{title}</Card.Title>
        <Card.Text>{subtitle}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default ExpCardView;
